<template>
    <form ref="password_form">
  
      <md-card style="box-shadow:none">
  
        <md-card-header class="md-card-header-icon md-card-header-primary">
          <div class="card-icon">
            <md-icon>key</md-icon>
          </div>
          <h2 class="title" style="font-weight:bold!important">
            Password
          </h2>
        </md-card-header>
  
        <md-card-content>
          <div class="md-layout">
            <div class="md-layout-item md-size-100">
              <md-field class="md-invalid">
                <label>New Password</label>
                <md-input v-model="user.password" type="password"/>
                <validation-error :errors="apiValidationErrors.password"/>
              </md-field>
              <md-field class="md-invalid">
                <label>Confirm New Password</label>
                <md-input v-model="user.password_confirmation" type="password"/>
                <validation-error :errors="apiValidationErrors.password_confirmation"/>
              </md-field>
            </div>
          </div>
        </md-card-content>
  
      </md-card>
  
    </form>
  </template>
  
  <script>
    import {ValidationError} from "@/components";
    export default {
      name: "add-password-card",
  
      props: {
        user: Object,
        apiValidationErrors: Object
      },

       watch: {  
        'user.password'(value){  
          this.apiValidationErrors.password = [];
        },
        'user.password_confirmation'(value){  
          this.apiValidationErrors.password_confirmation = [];
        }
      },
  
      components: {ValidationError},
  
  
    };
  </script>
  